module.exports = __webpack_public_path__ + "img/360x520-1.4badcee2.jpg";